import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export const PremiumQR = ({ url, title = "¡ESCANEA Y JUEGA!" }) => {
    return (
        <div className="text-center p-4 bg-white rounded-4 shadow-sm border" style={{ maxWidth: '350px', margin: '0 auto' }}>
            <h4 className="fw-bold text-dark mb-3 text-uppercase">{title}</h4>
            
            <div className="d-flex justify-content-center bg-light p-3 rounded-3 mb-3 border">
                <QRCodeSVG 
                    value={url} 
                    size={220}
                    bgColor={"#f8f9fa"} 
                    fgColor={"#0f172a"} 
                    level={"H"} 
                    imageSettings={{
                        src: "/img/games/slotmachine/logotipo-five-digital-minds-azul.png", // Ajusta la ruta a tu logo real
                        x: undefined,
                        y: undefined,
                        height: 45,
                        width: 45,
                        excavate: true, 
                    }}
                />
            </div>
            
            <p className="small text-muted mb-2">
                Escanea el código QR para unirte al juego
                {/* Apunta con la cámara de tu celular para abrir el control remoto. */}
            </p>
            <div className="p-2 bg-light rounded text-break user-select-all small fw-bold text-secondary border mb-3">
                {url}
            </div>

            {/* NUEVO BOTÓN PARA ABRIR LA URL DIRECTO DESDE EL MODAL */}
            <button 
                className="btn btn-primary w-100 fw-bold" 
                onClick={() => window.open(url, '_blank')}
            >
                Abrir jugador aquí <i className="bi bi-box-arrow-up-right ms-1"></i>
            </button>
        </div>
    );
};